import {IForm} from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'type',
      type: 'select',
      label: '类型',
      placeholder: '请选择类型',
      rules: {required: true, message: '类型是必选的', trigger: 'blur'},
      options: [
        {title: '小程序', value: 0}
      ]
    },
    {
      field: 'name',
      type: 'input',
      label: '名称',
      placeholder: '请输入名称名称',
      rules: {required: true, message: '名称是必填的', trigger: 'blur'}
    },
    {
      field: 'cstatus',
      type: 'select',
      label: '状态',
      placeholder: '请选择状态',
      options: [
        {title: '正常', value: 0},
        {title: '认证到期', value: 1},
        {title: '封号', value: 2}
      ]
    },
    {
      field: 'manager',
      type: 'input',
      label: '管理员',
      placeholder: '请输入管理员',
    },
    {
      field: 'originalId',
      type: 'input',
      label: '原始ID',
      placeholder: '请输入原始ID',
    },
    {
      field: 'remark',
      type: 'textarea',
      label: '备注',
      placeholder: '请输入备注',
    },
  ],
  colLayout: 24,
  itemStyle: {}
}
